import { Permissions, usePermission } from 'src/rbac';

/**
 * May this user create a PTO request? Drives the "Request PTO" button's disabled state on the
 * schedule "My Requests" screen.
 *
 * Migrated (Segment B) from the legacy `permissionData.includes('Create PTO')` display-name
 * check to the instrumented `Permissions.CREATE_PTO` scopeKey. The catalog display name and the
 * paths.ts string still match each other (parity-verified in rbac-parity.test.ts), though both
 * are now "Request PTO" — THIN-8081 renamed this permission in catalog 5.20.0. Gating on the
 * scopeKey means the rename cannot reach this check; the check also emits RUM telemetry.
 */
export function useCreatePtoGate(): boolean {
  return usePermission(Permissions.CREATE_PTO);
}
